module.exports = __webpack_public_path__ + "img/XL_FICHES_INDIVIDUS.31219987.svg";